// frontend/src/layouts/error/Forbidden403.js
import React from "react";
import { Link } from "react-router-dom";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function Forbidden403() {
  return (
    <MDBox p={6} display="flex" flexDirection="column" alignItems="center" textAlign="center">
      <Icon fontSize="large">block</Icon>
      <MDTypography variant="h4" mt={2} mb={1}>
        403 – Accès refusé
      </MDTypography>
      <MDTypography variant="body2" color="text">
        Vous n’avez pas les permissions nécessaires pour accéder à cette page.
      </MDTypography>
      <MDButton variant="gradient" color="dark" component={Link} to="/dashboard" sx={{ mt: 3 }}>
        Retour au Dashboard
      </MDButton>
    </MDBox>
  );
}
